<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="retrait_actionnaire_ouinon"
      :live="liveSociete(25929)"
      v-model="sasSociete.declarerLeRetraitDActionnaire"
    />
    <div v-show="conditionRetrait">
      <data-iterator
        :list="sas.retraitActionnaires"
        add-new-text="Dissocier un actionnaire"
        :live="{ endpoint: 'sas-retrait-actionnaire', sasId: sas.id }"
        :icon="$getIcon('job')"
        :valids="valids"
        ref="dataIterator"
        hidePoints
        hideAddButton
        optional
      >
        <template v-slot:show-mode="{ item }">
          <div v-if="item.actionnaire">
            <h3>{{ item.actionnaire.fullName }}</h3>
            <p>{{ item.actionnaire.licenseNumber }}</p>
            <CaseACocherLive
              :opqIf="conditionRetrait"
              code="retrait_actionnaire_case"
              v-model="item.dissociation"
              :live="liveSasRetraitActionnaire(26105, item)"
            />
          </div>
        </template>
      </data-iterator>
      <DatePickerLive
        code="retrait_actionnaire_date"
        v-model="sasSociete.dateDissociationDActionnaires"
        :live="liveSociete(25942)"
        :opqIf="conditionRetrait"
      />
      <validate
        :that="
          sas.retraitActionnaires.length === 0 ||
          !sas.retraitActionnaires.every((x) => x.dissociation)
        "
        else="condition_dissociation_nombre"
      />
    </div>
    <validate
      :that="
        !conditionRetrait ||
        (conditionRetrait &&
          sas.retraitActionnaires.some((x) => x.dissociation))
      "
      else="condition_dissociation"
    />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import { Queue, Api } from "@/plugins/api"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object },
  },
  mounted() {
    this.sas.retraitActionnaires.forEach((x) => {
      x.lectureSeule = true
    })
  },
  methods: {
    pharmacienSelected(item, pharmacien) {
      Queue.enqueue(() =>
        Api.post("sas-ajout-actionnaire", {
          fileId: item.id,
          cle: "200",
          value: pharmacien.id,
        }).then(() => {
          item.actionnaire = pharmacien
        })
      )
    },
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    liveSasRetraitActionnaire(cle, item) {
      return { endpoint: "sas-retrait-actionnaire", cle: cle, fileId: item.id }
    },
    getTextSasActionnaireDropdown(sasActionnaire) {
      const value = sasActionnaire.id
      let text =
        sasActionnaire.fullName + " " + sasActionnaire.licenseNumber ||
        "Veuillez sélectionner un actionnaire"
      return { value, text }
    },
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionRetrait() {
      return this.estOui(this.sas.sasSociete.declarerLeRetraitDActionnaire)
    },
  },
}
</script>

<style></style>
